/* **********************************************************************************************************************
   **********************************************************************************************************************         
                                  ░██████╗░███████╗███╗░░██╗███████╗██████╗░░█████╗░██╗░░░░░
                                  ██╔════╝░██╔════╝████╗░██║██╔════╝██╔══██╗██╔══██╗██║░░░░░
                                  ██║░░██╗░█████╗░░██╔██╗██║█████╗░░██████╔╝███████║██║░░░░░
                                  ██║░░╚██╗██╔══╝░░██║╚████║██╔══╝░░██╔══██╗██╔══██║██║░░░░░
                                  ╚██████╔╝███████╗██║░╚███║███████╗██║░░██║██║░░██║███████╗
                                  ░╚═════╝░╚══════╝╚═╝░░╚══╝╚══════╝╚═╝░░╚═╝╚═╝░░╚═╝╚══════╝
 ************************************************************************************************************************
 ************************************************************************************************************************ */

 export enum OperatingSystemName {
  Mac = 'macos',
  Windows = 'windows'
}
export enum OfficeType {
  oldTsusho = 0,
  oldNyusho = 1,
  newTsusho = 2,
  newNyusho = 3,
  notSupport = -1
}

export enum DeviceType {
  DESKTOP = "DESKTOP",
  TABLET = "TABLET",
  MOBILE = "MOBILE"
}

export enum ButtonIconType {
  EDIT = "pi-pencil",
  DELETE = "pi-trash",
  BACK = "pi-angle-double-left",
  SORT = "pi-sort-alt",
  FILTER = "pi-filter",
  CLOSE = "pi-times",
  SEARCH = 'pi-search',
  CLOSE_DIALOG = 'pi-times-circle',
  PLUS = 'pi-plus'
}

export enum ButtonType {
  PRIMARY = "button-primary",
  SECONDARY = "button-secondary",
  TERTIARY = "button-tertiary",
  INFO = "button-info",
  DANGER = "button-danger",
  SHARE = "button-share",
  HYPERLINK = "hyperlink",
  REMOVE = "button-remove",
  TV_OFFICE_SELECT = "tv-btn-office-select"
}

export enum DateFormat {
  FULL_LONG_DATE = 'YYYY-MM-DD-HH-mm-ss',
  FULL_SHORT_DATE = 'YYYY/MM/DD',
  FULL_SHORT_DASH_DATE_TIME = 'YYYY-MM-DD HH:mm',
  FULL_DATE_HOUR = 'YYYY/MM/DD HH:mm:ss',
  DS_FULL_SHORT_DATE = 'YYYY-MM-DD',
  SHORT_DATE = 'yy/MM',
  YEAR = 'YYYY',
  YEAR_MONTH = 'YYYY/MM',
  JP_FULL_SHORT_DATE = 'yy年MM月DD日',
  JP_FULL_LONG_DATE = 'YYYY年MM月DD日',
  JP_LONG_DATE = 'YYYY年MM月',
  JP_YEAR = 'YYYY年',
  JP_MOTH = 'MM月',
  JP_DAY = 'DD日',
  JP_MONTH_DAY ='MM月DD日',
  JP_HOUR_MINUTE ='HH:mm',
  JP_HOUR='HH',
}

export enum DateType {
  Date = 'D1',
  Month = 'D2',
  Year = 'D3'
}

export enum LabelType {
  // mặc định
  DEFAULT = 'label-default',
  // type hình ngôi sao
  STAR = 'label-star',
  // type hình tròn
  CIRCLE = 'label-circle',
  // type hình vuông
  SQUARE = 'label-square',
  // hình chữ nhật
  RECTANGLE = 'label-rectangle',
  // hình giọt nước
  WATERDROPS = 'label-water-drops',
  // hình thoi
  RHOMBUS = 'label-rhombus'

}

export enum DialogType {
  delete,   //削除確認ダイアログ
  update,   //編集確認ダイアログ
  error,    //失敗ダイアログ
  save      //保存確認ダイアログ
}

export enum SaveType {
  SAVE = 1,
  NO = 2,
  CANCEL = 3
}

export enum KbnStatus {
  STATUS_EMPTY = 0,
  STATUS_NO_SCHEDULE = 1,
  STATUS_SCHEDULE = 2,
  STATUS_POSSIBLE = 3,
  STATUS_CARRY_OUT = 4,
  STATUS_CANCEL = 5
}

export enum CommonColor {
  ATTENTION_COLOR = "#FFD937",
}

export enum UserSettingMenu {
  // Cụm menu 1
  TV_CHECKSHEET_DISPLAY_SETTING = 11,
  TV_CHECKSHEET_COLUMN_SETTING = 12,
  TV_CHECKSHEET_CHANGE_PAGE_SETTING = 13,
  // Cụm menu 2
  TV_EXCREATION_DISPLAY_SETTING = 21,
  TV_EXCREATION_CHANGE_PAGE_SETTING = 22,
  // Cụm menu 3
  TV_USER_DB_DISPLAY_SETTING = 31,
  TV_USER_DB_SYSTEM_SETTING = 32,
  // Cụm menu 4
  TV_BATHE_DISPLAY_SETTING = 41,
  TV_BATHE_COLUMN_SETTING = 42,
  TV_BATHE_CHANGE_PAGE_SETTING = 43,
  // Cụm menu 5
  TV_DEVICE_NAME_SETTING = 51,
}

export const SPEED_RUN_TEXT_MARQUEE = 35;
// 5 mức tốc độ chạy chữ của 申し送り, 1 là tốc độ mặc định
export const MARQUEE_SPEED_RATES = [2.5, 2, 1.5, 1, 0.5];
export const DEFAULT_MARQUEE_SPEED_RATE = 1;
export enum Mode {
  WEB = 0,
  TV = 1
}
export enum MenuType{
  SCREEN = 1,
  IMG = 2,
  VIDEO = 3,
  YOUTUBE = 4,
  PDF = 5,
  WEB = 6,
  RELOAD = 7
}

export enum TrainingType {
  NONE = 0,
  IMPLEMENT = 4,
  CANCEL = 5
}

/* **********************************************************************************************************************
   **********************************************************************************************************************
                                          ██████╗░██████╗░░█████╗░██████╗░
                                          ██╔══██╗██╔══██╗██╔══██╗██╔══██╗
                                          ██║░░██║██████╔╝███████║██║░░██║
                                          ██║░░██║██╔═══╝░██╔══██║██║░░██║
                                          ██████╔╝██║░░░░░██║░░██║██████╔╝
                                          ╚═════╝░╚═╝░░░░░╚═╝░░╚═╝╚═════╝░
************************************************************************************************************************
************************************************************************************************************************ */

export enum DpadKeyCode {
  KEYCODE_DEFAULT = -1,
  KEYCODE_HOME = 3,
  KEYCODE_BACK = 4,
  KEYCODE_CALL = 5,
  KEYCODE_ENDCALL = 6,
  KEYCODE_0 = 7,
  KEYCODE_1 = 8,
  KEYCODE_2 = 9,
  KEYCODE_3 = 10,
  KEYCODE_4 = 11,
  KEYCODE_5 = 12,
  KEYCODE_6 = 13,
  KEYCODE_7 = 14,
  KEYCODE_8 = 15,
  KEYCODE_9 = 16,
  KEYCODE_STAR = 17,
  KEYCODE_POUND = 18,
  KEYCODE_DPAD_UP = 19,
  KEYCODE_DPAD_DOWN = 20,
  KEYCODE_DPAD_LEFT = 21,
  KEYCODE_DPAD_RIGHT = 22,
  KEYCODE_DPAD_CENTER = 23,
  KEYCODE_VOLUME_UP = 24,
  KEYCODE_VOLUME_DOWN = 25,
  KEYCODE_POWER = 26,
  KEYCODE_MENU = 82,
  KEYCODE_CHANGE_UP = 166,
  KEYCODE_CHANGE_DOWN = 167,
}

export enum DpadActionKey {
  ACTION_DOWN = 0,
  ACTION_UP = 1,
}
export enum DpadZoneType {
  DEFAULT = -1,
  MEMU = 0,
  HEADER = 1,
  SUB_HEADER = 2,
  SCREEN = 3,  
  DIALOG = 4,
  LOG_IN = 5,
  TV_LAYOUT = 6,
  TV_OFFICE_SELECT = 7,
  TV_USER_SETTINGS_MID = 8,
  TV_USER_SETTINGS_RIGHT = 9,
  TV_CORP_LOGIN = 10,
  TV_BLOCK_UNIT = 11,
  TV_USER_DB = 12,
  TV_NO_OFFICE = 13,
  SCREEN_NON_LAYOUT = 14,
  TV_POPUP_MULTI_SELECT = 15,
  MAIN = 16,
  TV_POPUP_SELECT = 17,
  TV_CORP_SELECT = 18,
}

export enum DpadDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
  MENU = 'menu'
}

export enum BathingScreenSortType {
  BY_ROOM = 0,
  BY_NAME = 1,
  BY_BATH_ORDER = 2
}

export enum ExcreationSortType {
  BY_EXCREATION_TIME = 0,
  BY_ROOM = 1,
  BY_NAME = 2,
}